 
// هنگامی که موردی از چک لیست انتخاب نشده باشد نمایش داده میشود.
const ChecklistEmpty = (): React.JSX.Element => {
  return (
    <div className="d-flex flex-column gap-6 justify-content-center align-items-center mt-7 mb-7">
      <div className="fs-1 fw-medium">
        برای مشاهده اطلاعات بیشتر ، روی یکی از گزینه های بالا کلیک کنید.
      </div>
    </div>
  );
};

export default ChecklistEmpty;
